import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

const TOKEN_KEY = "ah_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

client.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Resolve a media reference to a servable URL.
export const mediaUrl = (idOrUrl) => {
  if (!idOrUrl) return null;
  if (idOrUrl.startsWith("http") || idOrUrl.startsWith("/brand") || idOrUrl.startsWith("data:")) return idOrUrl;
  if (idOrUrl.startsWith("/api/")) return `${BACKEND_URL}${idOrUrl}`;
  return `${API}/media/${idOrUrl}/file`;
};

// ---------- Public ----------
export const getBrands = () => client.get("/brands").then((r) => r.data);
export const getBrandBySlug = (slug) => client.get(`/brands/${slug}`).then((r) => r.data);
export const getSettings = () => client.get("/settings").then((r) => r.data);
export const getFounder = () => client.get("/founder").then((r) => r.data);
export const getNews = () => client.get("/news").then((r) => r.data);
export const getNewsBySlug = (slug) => client.get(`/news/${slug}`).then((r) => r.data);
export const getHomepageNews = () => client.get("/news/homepage").then((r) => r.data);
export const submitContact = (payload) => client.post("/contact", payload).then((r) => r.data);

// ---------- Auth ----------
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);

// ---------- Admin: brands ----------
export const adminGetBrands = () => client.get("/admin/brands").then((r) => r.data);
export const adminCreateBrand = (payload) => client.post("/admin/brands", payload).then((r) => r.data);
export const adminUpdateBrand = (id, payload) => client.put(`/admin/brands/${id}`, payload).then((r) => r.data);
export const adminDeleteBrand = (id) => client.delete(`/admin/brands/${id}`).then((r) => r.data);
export const adminReorderBrands = (orderedIds) => client.post("/admin/brands/reorder", { orderedIds }).then((r) => r.data);

// ---------- Admin: settings / founder / news ----------
export const adminUpdateSettings = (payload) => client.put("/admin/settings", payload).then((r) => r.data);
export const adminUpdateFounder = (payload) => client.put("/admin/founder", payload).then((r) => r.data);
export const adminGetNews = () => client.get("/admin/news").then((r) => r.data);
export const adminGetNewsOne = (id) => client.get(`/admin/news/${id}`).then((r) => r.data);
export const adminCreateNews = (payload) => client.post("/admin/news", payload).then((r) => r.data);
export const adminUpdateNews = (id, payload) => client.put(`/admin/news/${id}`, payload).then((r) => r.data);
export const adminDeleteNews = (id) => client.delete(`/admin/news/${id}`).then((r) => r.data);
export const adminGetContact = () => client.get("/admin/contact").then((r) => r.data);

// ---------- Admin: media ----------
export const adminGetMedia = () => client.get("/admin/media").then((r) => r.data);
export const adminUploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminDeleteMedia = (id) => client.delete(`/admin/media/${id}`).then((r) => r.data);
export const adminGetStats = () => client.get("/admin/stats").then((r) => r.data);

export default client;
